import API from '../../../constants/api';

export const FETCH_STOCK_WAREHOUSE = '@@stockWarehouse/FETCH_STOCK_WAREHOUSE';
export const FETCH_STOCK_WAREHOUSE_FAILURE = '@@stockWarehouse/FETCH_STOCK_WAREHOUSE_FAILURE';
export const FETCH_STOCK_WAREHOUSE_SUCCESS = '@@stockWarehouse/FETCH_STOCK_WAREHOUSE_SUCCESS';

export const fetchPagesOfStockWarehouseAndSearch = (page, size, filters) => ({
    type: FETCH_STOCK_WAREHOUSE,
    api: `${API.STOCK_WAREHOUSE.STOCK_WAREHOUSE_LIST}?sortCol=id&sortOrder=DESC`,
    page,
    size,
    filters,
});
